module.exports = __webpack_public_path__ + "img/icon_5_27.1d8b0f4c.png";